module.exports = __webpack_public_path__ + "img/recept-no-image.2356b847.svg";